import {
    OverviewPage,
    AccountTransactionsOverviewPage,
    AccountTerms,
    AccountInvoicePage,
    AccountInvoiceSpecPage,
} from '.';

const routes = {
    path: 'account',
    name: 'Account',
    childRoutes: [
        { path: 'overview', name: 'Account overview', component: OverviewPage },

        {
            path: ':accountRef/transactions',
            name: 'Account transactions overview',
            component: AccountTransactionsOverviewPage,
        },

        {
            path: ':accountRef/terms',
            name: 'Account terms',
            component: AccountTerms,
        },

        {
            path: ':accountRef/invoice/specification',
            name: 'Account invoice specification',
            component: AccountInvoiceSpecPage,
        },

        {
            path: ':accountRef/invoice',
            name: 'Account invoice',
            component: AccountInvoicePage,
        },
    ],
};

export default routes;
